import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom';
import { Accordion } from './modules/accordion';
import { AddToFavourite } from './modules/addToFavourite';
import { Carousel } from './modules/carousel';
import { CookieManager } from './modules/cookieManager';
import { Countdown } from './modules/countdown';
import { FooterCta } from './modules/footerCta';
import { FormCta } from './modules/formCta';
import { GsapAnimations } from './modules/gsapAnimations';
import { ImageSlider } from './modules/imageSlider';
import { IsSticky } from './modules/isSticky';
import { LazyLoadImage } from './modules/lazyLoadImage';
import { LazyLoadVideo } from './modules/lazyLoadVideo';
import { LocationMap } from './modules/locationMap';
import { MediaAndTextSlider } from './modules/mediaAndTextSlider';
import { MegaMenu } from './modules/megaMenu';
import { PageHeader } from './modules/pageHeader';
import { PromoBanner } from './modules/promoBanner';
import { SecondaryNavigation } from './modules/secondaryNavigation';
import { SearchForm } from './modules/serachForm';
import { Stackla } from './modules/stackla';
import { Toggle } from './modules/toggle';
import TripBuilder from './modules/TripBuilder';
import { VerticalSlider } from './modules/verticalSlider';
import { Wishlist } from './modules/wishlist';
import { YTMediaController } from './modules/youtube-media';
import { StateProvider } from './state/state';
import { MobileMenu } from './modules/mobileMenu';
import SearchUpcomingEvents from './modules/SearchUpcomingEvents';
import { SideNav } from './modules/sideNav';
import { Popup } from './modules/popup';
import '../styles/app.css';
/**
 * Constants
 */
const addToWishlistButtons = document.querySelectorAll('[data-wishlist]');
const accordions = document.querySelectorAll('.accordion');
const carousels = document.querySelectorAll('.carousel');
const cookieBanner = document.getElementById('cookie-banner');
const countdown = document.getElementById('countdown-timer');
const dealsTermsAndConditions = document.querySelectorAll('.deals-terms-conditions');
const footerCta = document.querySelector('.footer-cta');
const hero = document.getElementById('hero');
const searchHead = document.getElementById('search-head');
const imageSlider = document.querySelector('.image-slider');
const locationMap = document.querySelector('.location-map');
const megaMenu = document.getElementById('primary-menu-list');
const mobileMenu = document.getElementById('mobile-navigation');
const mediaAndTextSlider = document.querySelector('.media-and-text-slider');
const pageHead = document.getElementById('page-head');
const promotionalBanner = document.querySelector('.promotional-banner');
const stackla = document.querySelector('.stackla-widget');
const searchUpcomingEvents = document.getElementById('search-upcoming-events');
const verticalSliders = document.querySelectorAll('.vertical-slider');
const searchForm = document.getElementById('search-form');
const secondaryNavigationMenuToggle = document.getElementById('site-secondary-navigation-menu-toggle');
const sideNav = document.querySelector('.with-side-nav');
const tripBuilder = document.getElementById('trip-builder');
const shareItinerary = document.getElementById('share-itinerary');
const shareWishlist = document.getElementById('share-wishlist');
const wishlist = document.getElementById('wishlist');
const ytMediaEls = document.querySelectorAll('[data-yt-id]');
const ytMediaArr = [];
const popup = document.getElementById('scenic-popup');
if (addToWishlistButtons.length > 0) {
    Array.from(addToWishlistButtons, button => {
        new AddToFavourite(button);
    });
}
if (accordions.length > 0) {
    Array.from(accordions, accordion => {
        new Accordion({
            selector: accordion,
            trigger: '.accordion-header'
        });
    });
}
if (carousels.length > 0) {
    Array.from(carousels, carousel => {
        new Carousel(carousel);
    });
}
if (cookieBanner) {
    new CookieManager(cookieBanner);
}
if (countdown) {
    new Countdown(countdown);
}
if (dealsTermsAndConditions.length > 0) {
    Array.from(dealsTermsAndConditions, term => {
        new Toggle({
            selector: term,
            trigger: 'button.view-terms-conditions',
            altText: 'Hide Terms & Conditions -'
        });
    });
}
if (footerCta) {
    new FooterCta(footerCta);
}
new GsapAnimations();
if (imageSlider) {
    new ImageSlider(imageSlider);
}
if (sideNav) {
    new SideNav(sideNav);
}
if (locationMap) {
    new LocationMap(locationMap);
}
if (megaMenu) {
    new MegaMenu(megaMenu);
}
if (mobileMenu) {
    new MobileMenu(mobileMenu);
}
if (mediaAndTextSlider) {
    new MediaAndTextSlider(mediaAndTextSlider);
}
if (document.querySelectorAll('img[data-src]')) {
    new LazyLoadImage();
}
if (document.querySelectorAll('video.lazy')) {
    new LazyLoadVideo();
}
if (document.querySelectorAll('[data-sticky]')) {
    new IsSticky();
}
new PageHeader(hero);
new PageHeader(pageHead);
new PageHeader(searchHead);
if (promotionalBanner) {
    new PromoBanner(promotionalBanner);
}
if (searchUpcomingEvents) {
    const region = searchUpcomingEvents.getAttribute('data-region');
    const categories = searchUpcomingEvents.getAttribute('data-categories');
    if (region && categories) {
        ReactDOM.render(_jsx(SearchUpcomingEvents, { region: region, categories: categories }), searchUpcomingEvents);
    }
}
if (stackla) {
    new Stackla(stackla);
}
if (tripBuilder) {
    const questions = tripBuilder.getAttribute('data-questions');
    if (questions) {
        const builder = (_jsx(StateProvider, { children: _jsx(TripBuilder, { questions: questions }) }));
        ReactDOM.render(builder, tripBuilder);
    }
}
if (verticalSliders.length > 0) {
    Array.from(verticalSliders, slider => {
        new VerticalSlider(slider);
    });
}
if (secondaryNavigationMenuToggle) {
    new SecondaryNavigation(secondaryNavigationMenuToggle);
}
if (searchForm) {
    const close = searchForm.querySelector('#close-button');
    const open = document.getElementById('open-search');
    new SearchForm(open, close, searchForm);
}
if (shareItinerary) {
    const close = shareItinerary.querySelector('#close-button');
    const open = document.getElementById('open-share');
    new FormCta(open, close, shareItinerary);
}
if (shareWishlist) {
    const close = shareWishlist.querySelector('#close-button');
    const open = document.getElementById('open-share');
    new FormCta(open, close, shareWishlist);
}
if (wishlist) {
    new Wishlist(wishlist);
}
if (ytMediaEls.length > 0) {
    Array.from(ytMediaEls, ytMediaEl => {
        ytMediaArr.push(ytMediaEl);
    });
}
if (ytMediaArr.length > 0) {
    const ytMediaController = new YTMediaController(ytMediaArr);
    window.onYouTubeIframeAPIReady = () => ytMediaController.ready();
    ytMediaController.init();
}
if (popup) {
    new Popup(popup);
}
